<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
      require: false,
    },
    classHeader: {
      type: String,
      default: '',
      require: false,
    },
    hasEdit: {
      type: Boolean,
      require: false,
    },
    ignoreConfirm: {
      type: Boolean,
      require: false,
    },
    hasFooter: {
      type: Boolean,
      require: false,
    },
    formCollapsed: {
      type: Boolean,
      require: false,
    },
    triggerMask: {
      type: Boolean,
      require: false,
    },
    errors: {
      type: Object,
      require: false,
      default: () => {},
    },
    actionHeaderList: {
      type: Array,
      require: false,
      default: () => [],
    },
    minHeight: {
      type: Boolean,
      default: false,
      require: false,
    },
  },
  data() {
    return {
      openConfirm: false,
      type: 'edit',
      actionSubmit: () => {
        this.$emit('update')
      },
    }
  },
  computed: {
    actionHeaderListFilter: function() {
      return this.actionHeaderList.filter(function(actionHeader) {
        return actionHeader.hide !== true
      })
    },
  },
  watch: {
    errors() {
      if (this.errors) {
        this.$refs.observer.setErrors(this.errors)
      }
    },
  },
  methods: {
    handleActionHeader(actionHeader) {
      if (actionHeader.confirm) {
        this.openConfirm = true
        this.type = actionHeader.type
        this.actionSubmit = actionHeader.onclick
      } else {
        actionHeader.onclick()
      }
    },
    showConfirm() {
      if (this.ignoreConfirm) {
        this.$emit('update')
      } else {
        this.openConfirm = true
        this.actionSubmit = () => {
          this.$emit('update')
        }
      }
    },
    closeModalConfirm() {
      this.openConfirm = false
    },
    submit() {
      this.actionSubmit()
      this.closeModalConfirm()
    },
    getClassHeader() {
      return this.classHeader + (this.minHeight && ' min-height-40')
    },
  },
}
</script>

<template>
  <validation-observer ref="observer" v-slot="{ handleSubmit }">
    <CForm
      id="base-card-detail"
      class="position-relative"
      @submit.stop.prevent="handleSubmit(showConfirm)"
    >
      <CCard class="shadow-sm">
        <CCardHeader
          class="d-flex justify-content-between align-items-center p3"
          :class="getClassHeader()"
        >
          <h5 class="font-weight-bold mb-0">{{
            title || $route.meta.label
          }}</h5>
          <div>
            <CButton
              v-if="hasEdit"
              variant="ghost"
              @click="
                handleActionHeader({
                  type: 'edit',
                  onclick: function() {
                    $emit('edit')
                  },
                })
              "
            >
              <simple-line-icons icon="pencil" no-svg />
            </CButton>
            <CButton
              v-for="actionHeader in actionHeaderListFilter"
              :key="actionHeader.type"
              variant="ghost"
              @click="handleActionHeader(actionHeader)"
            >
              <simple-line-icons
                v-if="actionHeader.iconType === 'simple-line-icons'"
                :icon="actionHeader.icon"
                no-svg
              />
              <font-awesome-icon
                v-else-if="actionHeader.iconType === 'font-awesome-icon'"
                :icon="actionHeader.icon"
              />
              <CIcon v-else :name="actionHeader.icon" />
            </CButton>
          </div>
        </CCardHeader>
        <CCollapse :show="formCollapsed">
          <CCardBody>
            <slot></slot>
          </CCardBody>
        </CCollapse>
        <CCardFooter v-if="hasFooter" align="right">
          <slot name="action">
            <CButton color="primary" type="submit">
              {{ $t('confirm.edit.btn') }}
            </CButton>
            <CButton
              type="button"
              color="dark"
              class="ml-2"
              variant="outline"
              @click="$emit('cancel')"
            >
              {{ $t('common.cancel') }}
            </CButton>
          </slot>
        </CCardFooter>
      </CCard>
      <div v-if="triggerMask" class="mask" />
    </CForm>
    <BaseModalConfirm
      :show.sync="openConfirm"
      :type.sync="type"
      @closeModal="closeModalConfirm"
      @submit="submit"
    />
  </validation-observer>
</template>

<style lang="scss" scoped>
#base-card-detail {
  .min-height-40 {
    min-height: 40px;
  }
  .card-detail-header {
    height: 60px;
    color: $custom-filter-box-card-title-color;
    background-color: $feelline-bg-primary;
  }

  ::v-deep .mask {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    background-color: gray;
    opacity: 0.5;
  }
}
</style>
